import React, { FunctionComponent } from 'react';
import T from './Text';
import { PriceProps } from './PriceTypes';

const Price: FunctionComponent<PriceProps> = ({
  className = '',
  currency,
  price,
  discount,
  realPrice,
  s,
  currencyColor,
  priceColor,
  discountColor = 'base-main',
  realPriceColor,
  responsive,
  loading,
  ...other
}) => {
  const hasRealPrice = !!(
    realPrice && parseFloat(realPrice) > parseFloat(price)
  );
  const blurColor =
    discount || hasRealPrice ? 'text-blur-red-main' : 'text-blur-base-main';

  return (
    <p className={className} {...other}>
      <T
        className={loading ? blurColor : ''}
        type={s ? 'currency-s' : 'currency'}
        color={
          currencyColor ||
          (discount || hasRealPrice ? 'red-main' : 'base-main')
        }
        responsive={responsive}
      >
        {currency}
      </T>
      <T
        className={loading ? blurColor : 'ml-4'}
        type={s ? 'price-s' : 'price'}
        color={
          priceColor || (discount || hasRealPrice ? 'red-main' : 'base-main')
        }
        responsive={responsive}
      >
        {price.toLocaleString()}
      </T>
      {hasRealPrice && (
        <T
          type={s ? 'discount-s' : 'discount'}
          color={realPriceColor || discountColor}
          responsive={responsive}
          className={loading ? 'text-blur-base-main' : 'line-through'}
        >
          {currency}
          {realPrice ? realPrice.toLocaleString() : ''}
        </T>
      )}
      {discount && (
        <T
          className={loading ? 'text-blur-base-main' : ''}
          type={s ? 'discount-s' : 'discount'}
          style={{ fontWeight: 'bold', textDecoration: 'none' }}
          color={discountColor}
          responsive={responsive}
        >
          {discount}
        </T>
      )}
    </p>
  );
};

export default Price;
